"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.LoadingIndicator = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _withSpacing = _interopRequireWildcard(require("../withSpacing"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = {
  "screen-small": "(max-width: 539px)",
  "screen-gt-small": "(min-width: 540px)",
  "screen-medium": "(max-width: 959px)",
  "screen-gt-medium": "(min-width: 960px)",
  "screen-large": "(max-width: 1247px)",
  "screen-gt-large": "(min-width: 1248px)",
  "screen-x-large": "(max-width: 1919px)",
  "screen-gt-x-large": "(min-width: 1920px)",
  "loadingIndicator": "tcl__LoadingIndicator-2e286961",
  "inverted": "tcl__LoadingIndicator-b27c67bb",
  "size-18": "tcl__LoadingIndicator-efc979e6",
  "size-24": "tcl__LoadingIndicator-c04a1b8b",
  "size-36": "tcl__LoadingIndicator-009c41a3",
  "size-48": "tcl__LoadingIndicator-f48484cd"
};
/**
 * Loading indicator component.
 */

const LoadingIndicator = ({
  className,
  isInverted,
  size
}) => {
  const classNames = (0, _classnames.default)(styles.loadingIndicator, {
    [styles.inverted]: isInverted,
    [styles[`size-${size}`]]: size
  }, className);
  return /*#__PURE__*/_react.default.createElement("span", {
    className: classNames
  });
};

exports.LoadingIndicator = LoadingIndicator;
LoadingIndicator.displayName = "LoadingIndicator";
LoadingIndicator.propTypes = { ..._withSpacing.propTypes,

  /**
   * Whether the loading indicator is white or not.
   */
  isInverted: _propTypes.default.bool,

  /**
   * Loading indicator size in px.
   */
  size: _propTypes.default.oneOf([18, 24, 36, 48]),

  /**
   * Any additional css classes
   */
  className: _propTypes.default.string
};
LoadingIndicator.defaultProps = {
  size: 18,
  isInverted: false,
  className: ''
};

var _default = (0, _withSpacing.default)(LoadingIndicator);

exports.default = _default;